import "./QuoteChangeComponent.scss";
import template from "./QuoteChangeComponent.html";
import {IComponentOptions} from "angular";
import {QuoteViewModel} from "../../models/QuoteViewModel";

export const QuoteChange = "tfQuoteChange";

export function quoteChange(): IComponentOptions {
    return {
        template,
        bindings: {
            model: "<quote"
        },
        controllerAs: "ctrl",
        controller: QuoteChangeComponentController
    };
}

export class QuoteChangeComponentController {
    public readonly model: QuoteViewModel;
}
